import axios from "axios";
import type { CreateClientConfig } from "../client/client.gen";

const LOGIN_PATH = "/login";

const SKIP_REDIRECT_URL_SUBSTRINGS = ["/auth/is-authenticated", "/auth/login"];

function shouldRedirectOn401(requestUrl: string | undefined): boolean {
  if (!requestUrl) return true;
  return !SKIP_REDIRECT_URL_SUBSTRINGS.some((s) => requestUrl.includes(s));
}

export const createClientConfig: CreateClientConfig = (config) => {
  const baseConfig = {
    ...config,
    withCredentials: true,
    baseURL: import.meta.env.VITE_BACKEND_URL,
  };

  const instance = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    withCredentials: true,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const requestUrl = error.config?.url;

      if (status === 403 && shouldRedirectOn401(requestUrl)) {
        window.location.href = LOGIN_PATH;
      }

      return Promise.reject(error);
    },
  );

  return {
    ...baseConfig,
    axios: instance,
  };
};
